import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import { MSEnum } from '@/commons/enumeration';
import commonFn from '@/commons/commonFunction';
class OrganizationUnitAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "TaskGo";
  controllerName = 'OrganizationUnits';

  /**
   * Lấy thông tin đơn vị và danh sách phòng ban con
   * @param {} param
   */
  totalUser(param) {
    let queryString = commonFn.objectToQueryString(param);
    let request = {
      url: [this.getAPIUrl(), '/totalUser?', queryString].join(''),
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin đơn vị và danh sách phòng ban trong đơn vị
   * @param {} param
   */
  totalUserAll(param) {
    let queryString = commonFn.objectToQueryString(param);
    let request = {
      url: [this.getAPIUrl(), '/totalUserAll?', queryString].join(''),
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin đơn vị và danh sách phòng ban con
   * @param {} param
   */
  getDepartmentOfOrganizationUnit(param) {
    let queryString = commonFn.objectToQueryString(param);
    let request = {
      url: [this.getAPIUrl(), '/department?', queryString].join(''),
    };
    return httpClient.getAsync(request);
  }
  /**
   * save phòng ban
   * vdgiang 27/3/2023
   */
  save(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: {
        Ignores: [],
        Model: payload,
        ReturnRecord: true,
      },
    };
    if (payload.State == MSEnum.ModelState.Update) {
      return httpClient.putAsync(request);
    }
    return httpClient.postAsync(request);
  }

  /**
   * Them/Sua/Xoa nhieu
   * @param {*} payload
   * @returns
   * CreateBy: vdgiang 27/3/2023
   */
  async multiSubmit(payload) {
    let request = {
      url: this.getAPIUrl() + '/submit',
      data: payload,
    };

    return await httpClient.postAsync(request, true);
  }

  /**
   * Lấy dữ liệu phòng ban
   * vdgiang 27/3/2023
   */
  getDepartment(payload) {
    let request = {
      url: this.getAPIUrl() + `/edit/${payload}`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * load tree theo cơ cấu cha con
   * @param {param} payload
   * @returns
   *vdgiang 27/3/2023
   */
  getListTree(payload) {
    let request = {
      url: this.getAPIUrl() + '/list',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  
    /**
     * Lấy tổng số đơn vị
     * @param {*} payload 
     * @returns 
     */
     getTotalOrganizationUnit(payload) {
      let request = {
          url: this.getAPIUrl() + "/list-summary",
          data: payload
      };
      return httpClient.postAsync(request);
  }

  /**
   * Validate trước khi xóa
   * @param {*} payload
   * @returns
   * VDGiang 27/3/2023
   */
  async validateDelete(payload) {
    let request = {
      url: this.getAPIUrl() + '/validateDelete',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy cấy cơ cấu
   * @param {number} organizationUnitID ID của đơn vị cha
   * @param {string} organizationUnitCode Code của đơn vị cần tìm
   * @param {string} organizationUnitName Tên đơn vị cần tìm
   * @param {boolean} isGetByRoleType Có lấy dữ liệu theo roleType của người dùng ko
   * @param {boolean} isExceptDepartment Có loại bỏ phòng ban ko
   * @param {boolean} inactive Có inactive ko
   * @param {boolean} isGetParentAndChildren Có lấy cả cha và con ko (chỉ dùng khi truyền organizationUnitID)
   * @returns Cây cơ cấu
   * @author: BMThang(12/12/2022)
   */
  getPagingTree(
    organizationUnitID = null,
    organizationUnitCode = '',
    organizationUnitName = '',
    isGetByRoleType = false,
    isExceptDepartment = false,
    inactive = false,
    isGetParentAndChildren = false
  ) {
    let request = {
      url: `${this.getAPIUrl()}/paging`,
      data: {
        CustomParam: {
          v_Inactive: inactive,
          v_OrganizationUnitCode: organizationUnitCode,
          v_OrganizationUnitID: organizationUnitID,
          v_OrganizationUnitName: organizationUnitName,
          v_IsGetByRoleType: isGetByRoleType,
          v_IsExceptDepartment: isExceptDepartment,
          v_IsGetParentAndChildren: isGetParentAndChildren,
        },
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách đơn vị
   * @param {number} skip skip
   * @param {number} take take
   * @param {string} filter filter
   * @param {string} sort sort
   * @param {string} columns danh sách cột lấy về
   * @param {string} emptyFilter emptyFilter
   * @returns Danh sách đơn vị
   * @author: BMThang(12/12/2022)
   */
  getPaging(
    skip = 0,
    take = 15,
    filter = '',
    sort = '',
    columns = '',
    emptyFilter = ''
  ) {
    let request = {
      url: `${this.getAPIUrl()}/list`,
      data: {
        skip,
        take,
        filter,
        sort,
        columns,
        emptyFilter,
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy số đơn vị
   * @param {string} filter filter
   * @param {string} columns danh sách cột lấy về
   * @returns Số đơn vị
   * @author: BMThang(12/12/2022)
   */
  getPagingSummary(filter = '', columns = '') {
    let request = {
      url: `${this.getAPIUrl()}/list-summary`,
      data: {
        filter,
        columns,
      },
    };
    return httpClient.postAsync(request);
  }
}

export default new OrganizationUnitAPI();
